import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { MEAT_API, CHAVE_API } from '../app.api';
import { Produto } from '../models/model';
import { Observable } from 'rxjs/Observable';
import { ErrorHandler } from '../app.error-handler';
import 'rxjs/add/operator/catch';
import { EquipamentoService } from './equipamento.service';



@Injectable()
export class DadosService {

    constructor(private http: Http,
        private equiService: EquipamentoService) { }

    empresa: any = {};

    buscaDados(cnpj: string): Observable<any> {
        this.equiService.registrarDispositivo(this.mascaraCNPJ(cnpj))
                    .subscribe((registro: String) => {
        });
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('cnpj', this.mascaraCNPJ(cnpj));
        return this.http.get(`${MEAT_API}/api/web/dados`, new RequestOptions({ headers: headers }))
            .map((response) => {
                return response.json()
            })
            .map((dados) => {
                var empresa = {
                    cnpj_sem_mascara: cnpj,
                    dados: dados
                }
                return empresa;
            })
            .map((empresa) => {
                this.empresa = empresa;
            })
            .catch(ErrorHandler.handleError);
    }

    gravarDivulgacao(divulgacao: string): Observable<any> {
        const headers = new Headers();
        this.getEmpresa().dados.divulgacao = divulgacao;
        headers.append('Content-Type', 'application/json');
        headers.append('cnpj', this.getEmpresa().dados.cnpj);
        headers.append('chave', CHAVE_API);
        return this.http.post(`${MEAT_API}/api/dados/divulgacao`,
            JSON.stringify(this.getEmpresa().dados), new RequestOptions({ headers: headers }))
            .map((response) => response.json())
            .catch(ErrorHandler.handleError);
    }

    mascaraCNPJ(cnpj: string): string {
        cnpj = cnpj.replace(/\D/g, "")
        cnpj = cnpj.replace(/^(\d{2})(\d)/, "$1.$2")
        cnpj = cnpj.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
        cnpj = cnpj.replace(/\.(\d{3})(\d)/, ".$1/$2")
        cnpj = cnpj.replace(/(\d{4})(\d)/, "$1-$2")
        return cnpj
    }

    getEmpresa() {
        return this.empresa;
    }
}


// WEBPACK FOOTER //
// ./src/app/services/dados.service.ts